module.exports = __webpack_public_path__ + "static/logo_back_pocket-3bc3a0e043fa93c7f04d81de94a5428a.png";